<template>
    <div class="home">
        <iframe
            class="guahao"
            :src="src"
        >
        </iframe>
    </div>
</template>

<script>
export default {
    name: 'wz-guahao',
    data() {
        return {
            src: ''
        };
    },
    created() {
        let arr = [];
        let query = this.$route.query;
        let pagename = query.page || 'home';
        this.src = `https://expert.baidu.com/#/pages/guahao/${pagename}/index?`;
        for (let key in query) {
            if (key !== 'page') {
                arr.push(`${key}=${query[key]}`);
            }
        }
        this.src += arr.join('&');
    }
};
</script>

<style scoped>
.home {
    position: relative;
    height: 100vh;
    width: 100%;
    text-align: center;
}
.guahao {
    border: none;
    height: 99%;
    min-height: 520px;
    width: 520px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    box-shadow: 0 10px 50px rgba(0, 0, 0, 0.06);
}
</style>



// WEBPACK FOOTER //
// src/pages/wz/guahao.vue